import { render } from "./ComboBoxInput.vue?vue&type=template&id=8087f134&scoped=true&ts=true"
import script from "./ComboBoxInput.vue?vue&type=script&lang=ts"
export * from "./ComboBoxInput.vue?vue&type=script&lang=ts"

import "./ComboBoxInput.vue?vue&type=style&index=0&id=8087f134&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8087f134"]])

export default __exports__